import Vault from '@/libs/core/Vault'
import Vue from 'vue'

window.vault = Vault

window.events = new Vue()

window.flash = (details) => {
  window.events.$emit('flash', details)
}